import { ReactNode, createContext, useState } from "react";
export type DiscountCodeNameResults = { prefix?: string; suffix?: string };

const DiscountNameContext = createContext({
  discountName: {
    prefix: undefined,
    suffix: undefined,
  } as DiscountCodeNameResults,
  setDiscountName: (discountName: DiscountCodeNameResults) => {},
});

const DiscountNameContextProvider = ({ children }: { children: ReactNode }) => {
  const [discountName, setDiscountName] = useState<DiscountCodeNameResults>({
    prefix: undefined,
    suffix: undefined,
  });

  return (
    <DiscountNameContext.Provider value={{ discountName, setDiscountName }}>
      {children}
    </DiscountNameContext.Provider>
  );
};

export { DiscountNameContext, DiscountNameContextProvider };
